import { render } from './App';

const ROOT_ELEMENT_ID = 'favorites-provider-root';
const rootElement = document.getElementById(ROOT_ELEMENT_ID);

if (!rootElement) {
  throw new Error(`Element #${ROOT_ELEMENT_ID} not found.`);
}
render(rootElement);
